import React from 'react';
import { useTheme } from '../hooks/useTheme';
import { Toggle } from '../components/ui/Toggle';
import { Card } from '../components/ui/Card';
import { User, Bell, Ruler, HelpCircle, LogOut } from 'lucide-react';
export function ProfilePage() {
  const {
    theme,
    toggleTheme
  } = useTheme();
  return <div className="p-4 md:p-8 pb-24 max-w-2xl mx-auto" data-id="element-120">
      <h1 className="text-3xl font-bold text-text mb-8" data-id="element-121">Profile & Settings</h1>

      {/* User Info */}
      <div className="flex items-center space-x-4 mb-8" data-id="element-122">
        <div className="w-20 h-20 rounded-full bg-gradient-to-br from-teal-400 to-emerald-600 flex items-center justify-center text-white shadow-lg" data-id="element-123">
          <User size={32} data-id="element-124" />
        </div>
        <div data-id="element-125">
          <h2 className="text-xl font-bold text-text" data-id="element-126">Guest Angler</h2>
          <p className="text-text-muted" data-id="element-127">Member since 2024</p>
        </div>
      </div>

      <div className="space-y-6" data-id="element-128">
        {/* App Settings */}
        <section data-id="element-129">
          <h3 className="text-sm font-semibold text-text-muted uppercase tracking-wider mb-3 ml-1" data-id="element-130">
            App Settings
          </h3>
          <Card className="divide-y divide-border" data-id="element-131">
            <div className="p-4 flex items-center justify-between" data-id="element-132">
              <div className="flex items-center space-x-3" data-id="element-133">
                <div className="p-2 bg-gray-100 dark:bg-slate-800 rounded-lg" data-id="element-134">
                  {theme === 'dark' ? <svg className="w-5 h-5 text-indigo-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-135">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" data-id="element-136" />
                    </svg> : <svg className="w-5 h-5 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-137">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" data-id="element-138" />
                    </svg>}
                </div>
                <span className="font-medium text-text" data-id="element-139">Dark Mode</span>
              </div>
              <Toggle isOn={theme === 'dark'} onToggle={toggleTheme} data-id="element-140" />
            </div>

            <div className="p-4 flex items-center justify-between" data-id="element-141">
              <div className="flex items-center space-x-3" data-id="element-142">
                <div className="p-2 bg-gray-100 dark:bg-slate-800 rounded-lg" data-id="element-143">
                  <Bell className="w-5 h-5 text-blue-500" data-id="element-144" />
                </div>
                <span className="font-medium text-text" data-id="element-145">Notifications</span>
              </div>
              <Toggle isOn={true} onToggle={() => {}} data-id="element-146" />
            </div>

            <div className="p-4 flex items-center justify-between" data-id="element-147">
              <div className="flex items-center space-x-3" data-id="element-148">
                <div className="p-2 bg-gray-100 dark:bg-slate-800 rounded-lg" data-id="element-149">
                  <Ruler className="w-5 h-5 text-emerald-500" data-id="element-150" />
                </div>
                <span className="font-medium text-text" data-id="element-151">Units (Imperial)</span>
              </div>
              <Toggle isOn={true} onToggle={() => {}} data-id="element-152" />
            </div>
          </Card>
        </section>

        {/* Support */}
        <section data-id="element-153">
          <h3 className="text-sm font-semibold text-text-muted uppercase tracking-wider mb-3 ml-1" data-id="element-154">
            Support
          </h3>
          <Card className="divide-y divide-border" data-id="element-155">
            <button className="w-full p-4 flex items-center justify-between hover:bg-gray-50 dark:hover:bg-slate-800 transition-colors text-left" data-id="element-156">
              <div className="flex items-center space-x-3" data-id="element-157">
                <HelpCircle className="w-5 h-5 text-text-muted" data-id="element-158" />
                <span className="font-medium text-text" data-id="element-159">Help & FAQ</span>
              </div>
            </button>
            <button className="w-full p-4 flex items-center justify-between hover:bg-gray-50 dark:hover:bg-slate-800 transition-colors text-left text-red-500" data-id="element-160">
              <div className="flex items-center space-x-3" data-id="element-161">
                <LogOut className="w-5 h-5" data-id="element-162" />
                <span className="font-medium" data-id="element-163">Log Out</span>
              </div>
            </button>
          </Card>
        </section>

        <div className="text-center text-sm text-text-muted pt-4" data-id="element-164">
          <p data-id="element-165">FishFinder v1.0.0</p>
        </div>
      </div>
    </div>;
}